import type { FormSelectProps } from '../types';
import type { FieldValues } from 'react-hook-form';

import { Select } from '@/components/Select';

import { FormFieldShell } from '../FormFieldShell';

export const EMPTY_SELECT_VALUE = '__none__';

export const FormSelect = <TFieldValues extends FieldValues = FieldValues>(
  props: FormSelectProps<TFieldValues>,
) => {
  const {
    name,
    label,
    hint,
    placeholder,
    description,
    isRequired,
    options,
    disabled,
    searchable,
    onChange,
    selectProps,
  } = props;
  return (
    <FormFieldShell
      name={name}
      description={description}
      render={({ field, fieldState, fieldId }) => (
        <Select
          id={fieldId}
          value={field.value ? String(field.value) : EMPTY_SELECT_VALUE}
          onValueChange={(newValue) => {
            const actualValue =
              newValue === EMPTY_SELECT_VALUE ? null : newValue || null;
            field.onChange(actualValue);
            if (actualValue !== null) {
              onChange?.(actualValue);
            }
          }}
          options={options}
          label={label}
          aria-label={label}
          isRequired={isRequired}
          hint={hint}
          placeholder={placeholder ?? label}
          searchPlaceholder={label ? `${label}...` : undefined}
          disabled={disabled}
          searchable={searchable}
          isInvalid={fieldState.invalid}
          aria-invalid={fieldState.invalid}
          {...selectProps}
        />
      )}
    />
  );
};
